(function () {
  'use strict';

  /**
   * @typedef {object} ChannelConfigField
   * @property {string} label
   * @property {string} name
   *
   * @typedef {object} ChannelConfig
   * @property {string} id
   * @property {string} name
   * @property {ChannelConfigField[]} fields
   */

  angular
    .module('settings.wepster')
    .controller('settingsWepsterCtrl', SettingsWepsterCtrl);

  SettingsWepsterCtrl.$inject = ['WepsterSettings', '$mdToast', '$translate'];

  /**
   * @param {import('./types').WepsterSettings} WepsterSettings
   * @param {angular.material.IToastService} $mdToast
   * @param {angular.translate.ITranslateService} $translate
   */
  function SettingsWepsterCtrl(WepsterSettings, $mdToast, $translate) {
    const vm = this;

    vm.webhookUrl = window.location.origin + '/api/wepster/webIncome';

    vm.model = WepsterSettings.get();

    /** @type {ChannelConfig[]} */
    vm.channels = [
      {
        id: 'telegram',
        name: 'Telegram',
        fields: [
          {
            name: 'token',
            label: 'Telegram connection id',
          },
        ],
      },
      {
        id: 'echat',
        name: 'E-Chat (Viber)',
        fields: [
          {
            name: 'token',
            label: 'E-chat connection id',
          },
        ],
      },
      {
        id: 'whatsapp',
        name: '360dialog.com (WhatsApp)',
        fields: [
          {
            name: 'token',
            label: '360dialog.com connection id',
          },
          {
            name: 'templateName',
            label: 'templateName',
          },
          {
            name: 'templateLanguageCode',
            label: 'templateLanguageCode',
          },
        ],
      },
      {
        id: 'alphasms',
        name: 'AlphaSms (Viber)',
        fields: [
          {
            name: 'token',
            label: 'AlphaSms connection id',
          },
          {
            name: 'alphasmsPageId',
            label: 'alphasmsPageId',
          },
        ],
      },
    ];

    vm.save = () => {
      this.model = WepsterSettings.save(this.model);

      $mdToast.show(
        $mdToast
          .simple()
          .textContent(
            $translate.instant('settings.integrations.settings.updated'),
          )
          .position('bottom right')
          .hideDelay(5000),
      );
    };
  }
})();
